import memoizeOne from "memoize-one";
import { TableColumn } from "react-data-table-component";
import { Organisation, OrganisationType } from "src/sdk/models/Organisation";
import DropdownOrganisation from "./ChildComponent/DropdownOrganisation";

export const OrganisationsColumns = memoizeOne(
    (
        fieldsOrganisation: (values: Organisation) => void,
        usersOrganisation: (values: Organisation) => void,
        onEditOrganisation: (values: Organisation) => void,
    ): TableColumn<Organisation>[] => {
        return [
            {
                id: "organisationUniqueKey",
                selector: (row: any) => row.organisationUniqueKey,
                sortable: true,
                name: "Organization Unique Key",
                width: "20%",
            },
            {
                id: "name",
                selector: (row: any) => row.name,
                sortable: true,
                name: "Organization Name",
            },
            {
                id: "type",
                selector: (row: any) => {
                    switch (row.type) {
                        case OrganisationType.Facility:
                            return "F";
                        case OrganisationType.FacilityGroup:
                            return "FG";
                        default:
                            return row.type;
                    }
                },
                sortable: true,
                name: "Type",
            },
            {
                cell: (row: any) => {
                    return (
                        <div className="m-auto">
                            <DropdownOrganisation
                                values={row as Organisation}
                                id={row.id as number}
                                fieldsOrganisation={fieldsOrganisation}
                                usersOrganisation={usersOrganisation}
                                onEditOrganisation={onEditOrganisation}
                            />
                        </div>
                    );
                },
                width: "150px",
            },
        ];
    },
);
